<template>
  <div class="container m-0 position-relative">
    <div class="d-flex flex-wrap justify-content-between align-items-center fondo-terciario rounded-3 px-2 sombra-sm rounded-top-0 border-top borde-secundario">
      <div class="d-flex flex-wrap justify-content-start align-items-center overflow-hidden gap-3">
        <button v-if="hasManejarHorariosPermission"
            class="btn-menu-2 fs-6 d-inline-flex gap-2 py-1 texto-secundario"
            :class="{'active-btn': MenuVisible == 1}"
            @click="MenuVisible = 1"
        >
            {{ $t('horariosBackOffice') }}
        </button>
        <button v-if="hasManejarAusenciasSuplenciasPermission"
            class="btn-menu-2 fs-6 d-inline-flex gap-2 py-1 texto-secundario"
            :class="{'active-btn': MenuVisible == 2}"
            @click="MenuVisible = 2"
        >
            <span>{{ $t('ausenciasSuplenciasDocentes') }}</span>
        </button>
        <button v-if="hasManejarDatosFaltantesPermission"
            class="btn-menu-2 fs-6 d-inline-flex gap-2 py-1 texto-secundario"
            :class="{'active-btn': MenuVisible == 3}"
            @click="MenuVisible = 3"
        >
            {{ $t('datosFaltantes') }}
        </button>
      </div>
      
      <div v-if="MenuVisible == 1" class="d-flex flex-wrap justify-content-start align-items-center overflow-hidden gap-3">
        <a v-if="hasVerDocumentacionPermission" href="https://docs.google.com/document/d/126aQ2EA22q3Xnv12g1gHca1cVnsCSC9kDzT7_FTsjwY/edit?usp=sharing"
          class="d-flex flex-row text-decoration-none align-items-center justify-content-start m-1 px-1" target="_blank">
          <p class="m-0 fs-6 texto-secundario">{{ $t('documentacion') }}</p>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" class="stroke-secundario" xmlns="http://www.w3.org/2000/svg">
            <path id="Vector" d="M10.0002 5H8.2002C7.08009 5 6.51962 5 6.0918 5.21799C5.71547 5.40973 5.40973 5.71547 5.21799 6.0918C5 6.51962 5 7.08009 5 8.2002V15.8002C5 16.9203 5 17.4801 5.21799 17.9079C5.40973 18.2842 5.71547 18.5905 6.0918 18.7822C6.5192 19 7.07899 19 8.19691 19H15.8031C16.921 19 17.48 19 17.9074 18.7822C18.2837 18.5905 18.5905 18.2839 18.7822 17.9076C19 17.4802 19 16.921 19 15.8031V14M20 9V4M20 4H15M20 4L13 11" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </a>
        <a href="https://canva.link/6nrv0ba1xmnq34p"
          class="d-flex flex-row text-decoration-none align-items-center justify-content-start m-1 px-1" target="_blank">
          <p class="m-0 fs-6 texto-secundario">{{ $t('instructivo') }}</p>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" class="stroke-secundario" xmlns="http://www.w3.org/2000/svg">
            <path id="Vector" d="M10.0002 5H8.2002C7.08009 5 6.51962 5 6.0918 5.21799C5.71547 5.40973 5.40973 5.71547 5.21799 6.0918C5 6.51962 5 7.08009 5 8.2002V15.8002C5 16.9203 5 17.4801 5.21799 17.9079C5.40973 18.2842 5.71547 18.5905 6.0918 18.7822C6.5192 19 7.07899 19 8.19691 19H15.8031C16.921 19 17.48 19 17.9074 18.7822C18.2837 18.5905 18.5905 18.2839 18.7822 17.9076C19 17.4802 19 16.921 19 15.8031V14M20 9V4M20 4H15M20 4L13 11" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </a>
      </div>
    </div>

    <div v-if="MenuVisible == 1" class="d-flex flex-column gap-2">
        <HorariosBackOfficePage/>
    </div>

    <div v-if="MenuVisible == 2" class="d-flex flex-column gap-2">
        <AusenciasSuplenciasDocentesPage/>
    </div>
<!-- 
    <div v-if="MenuVisible == 3" class="d-flex flex-column gap-2">
        <VerGrupos/>
    </div> -->

  </div>
</template>

<script>
import { ref, onMounted, computed, watch } from 'vue';
import {useStore} from "vuex";
import {useRouter} from "vue-router";
import { useI18n } from 'vue-i18n';
import HorariosBackOfficePage from './HorariosBackOfficePage.vue';
import AusenciasSuplenciasDocentesPage from './AusenciasSuplenciasDocentesPage.vue';

export default {
  name: 'RrhhPage',
   components: {
    HorariosBackOfficePage,
    AusenciasSuplenciasDocentesPage
   },
  setup() {
    const { t } = useI18n();
    const router = useRouter();
    const store = useStore();
    const user = computed(() => store.state.user);
    const MenuVisible = ref(1);
    var hasManejarDatosFaltantesPermission = ref(false);
    var hasManejarAusenciasSuplenciasPermission = ref(false);
    var hasManejarHorariosPermission = ref(false);
    var hasVerDocumentacionPermission = ref(false);


    const checkAuth = async  () => {
      if (user.value && user.value.personasPermisos) {
        var permisoAComprobar = 'ManejarDatosFaltantes'
        if (user.value.personasPermisos.some(persPermiso => persPermiso.idPermisoNavigation?.permiso === permisoAComprobar) || 
          user.value.personasRoles.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.permiso === permisoAComprobar))){
          hasManejarDatosFaltantesPermission.value = true;
        }

        permisoAComprobar = 'ManejarAusenciasSuplencias'
        if (user.value.personasPermisos?.some(persPermiso => persPermiso.idPermisoNavigation?.permiso === permisoAComprobar) || 
          user.value.personasRoles?.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.permiso === permisoAComprobar)))
        {
          hasManejarAusenciasSuplenciasPermission.value = true;
        }

        permisoAComprobar = 'ManejarHorarios'
        if (user.value.personasPermisos?.some(persPermiso => persPermiso.idPermisoNavigation?.permiso === permisoAComprobar) || 
            user.value.personasRoles?.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.permiso === permisoAComprobar)))
        {
            hasManejarHorariosPermission.value = true;
        }

        permisoAComprobar = 'VerDocumentacion'
        if (user.value.personasPermisos?.some(persPermiso => persPermiso.idPermisoNavigation?.permiso === permisoAComprobar) || 
            user.value.personasRoles?.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.permiso === permisoAComprobar)))
        {
            hasVerDocumentacionPermission.value = true;
        }

        if (hasManejarDatosFaltantesPermission.value || hasManejarAusenciasSuplenciasPermission.value || hasManejarHorariosPermission.value || hasVerDocumentacionPermission.value){
          console.log("Tiene Permiso")
        }
        else{
          console.log('Usuario no tiene permiso a acceder.');
          await router.push('/');
        }
      }
    };

    onMounted(() => {
      const lastUpdate = localStorage.getItem("lastUpdate");
      const today = new Date().toISOString().split("T")[0]; // Obtiene solo la fecha (YYYY-MM-DD)

      if (lastUpdate !== today) {
        localStorage.setItem("lastUpdate", today);
        window.location.reload(); // Recarga la página solo si no se ha recargado hoy
      }
      // Load saved menu preference
      const savedMenu = localStorage.getItem('rrhhPageMenuVisible');
      if (savedMenu) {
        MenuVisible.value = parseInt(savedMenu);
      }
      checkAuth();
    });

    // Watch for changes in MenuVisible and save to localStorage
    watch(MenuVisible, (newVal) => {
      localStorage.setItem('rrhhPageMenuVisible', newVal.toString());
    });

    return {
      checkAuth,
      t,
      MenuVisible,
      hasManejarDatosFaltantesPermission,
      hasManejarAusenciasSuplenciasPermission,
      hasManejarHorariosPermission,
      hasVerDocumentacionPermission,
    };
  },
};
</script>

<style>
.permissions-list {
  margin-top: 10px;
}

.roles-column {
  width: 250px; /* Fixed width for roles column */
}
</style>

